import { Stack } from "@mantine/core"
import { LabelWithTooltip, TagsInput } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const TagsInputField = (fields: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {fields.tooltip && (
      <LabelWithTooltip
        label={fields.label}
        hoverHelperText={fields.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={fields.required ?? false}
      />
    )}
    <TagsInput
      key={fields.name}
      label={!fields.tooltip ? fields.label : undefined}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      classNames={fields.customClass}
      clearable
      {...form.getInputProps(fields.name)}
      onChange={(value) => {
        form.setFieldValue(fields.name, value)
        form.validateField(fields.name)
      }}
    />
  </Stack>
)
